export default 'dashboardTargetsPage';
